import React, { memo } from "react";
import { Person, Phone } from "@mui/icons-material";
import { Booking } from "../../../models/booking";
import { getCar } from "../../../services/carsService";
import { getDriver } from "../../../services/driverService";
import "../../../../styles/commonStyle.css"

interface BookingCommunicationDetailsProps {
  booking: Booking;
}

const BookingCommunicationDetailsReadOnly: React.FC<BookingCommunicationDetailsProps> = ({ booking }) => {



  return (
    <div className="bg-white border rounded shadow-sm p-4 text-start" style={{ fontFamily: "Segoe UI, sans-serif", }}>
      <div className="mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="fw-bold" style={{ fontSize: "1.1rem", color: "#2c3e50" }}>
            Passenger Information
        </div>

        </div>

      </div>

      <div className="d-flex align-items-center mb-3" style={{ color: "#495057" }}>
        <Person fontSize="small" style={{ color: "#28a745", marginRight: "0.75rem" }} />
        <div>
          <div className="customTextXs fw-bold"> Name </div>
          <div>{booking.name}</div>
        </div>
      </div>

      <div className="d-flex align-items-center" style={{ color: "#495057" }}>
        <Phone fontSize="small" style={{ color: "#dc3545", marginRight: "0.75rem" }} />
        <div>
          <div className="customTextXs fw-bold">Phone Number</div>
          <div>{booking.phone}</div>
        </div>
      </div>
    </div>
  );
};

export default memo(BookingCommunicationDetailsReadOnly);
